import { Component, EventEmitter, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, map } from "rxjs";
import { AuthenticationService } from "../../../core/core";
import { ActivityService } from "../../services/activity.service";
import { ActivityTypeBaseComponent } from "../activity-type-base/activity-type-base.component";
import { InspectionApiService, InspectionDefinition } from "../../../inspections/inspections";
import { generate, observe } from "fast-json-patch";
import { AzureSearchService } from "../../../azure-search/azure-search";

@Component({
  selector: "common-activity-inspection",
  templateUrl: "./activity-inspection.component.html",
  styleUrls: ["./activity-inspection.component.scss"],
})
export class ActivityInspectionComponent extends ActivityTypeBaseComponent {
  @Output() fileUploaded = new EventEmitter<boolean>();
  inspection$: Observable<InspectionDefinition>;

  constructor(
    activityService: ActivityService,
    authService: AuthenticationService,
    toastr: ToastrService,
    private inspectionApiService: InspectionApiService,
    private azureSearchService: AzureSearchService,
  ) {
    super(activityService, authService, toastr);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.inspection$ =
      this.activity.status == "Open" || this.activity.status == "InProgress"
        ? this.inspectionApiService.get(this.activity.metadata.InspectionId)
        : this.azureSearchService.getOne(this.activity.metadata.InspectionId, "inspections");
  }

  inspectionChanged() {
    if (this.activity.status == "InProgress") {
      return;
    }

    this.activity.status = "InProgress";
    var operation = [{ op: "replace", path: "/status", value: this.activity.status }];
    this.activityService.jsonPatchWithPartitionKey(this.activity.id, operation, this.activity.accountId).subscribe(result => {});
  }

  inspectionSubmitted() {
    // reason fortimeout is because we want the indexer to run, i know a hack but we really need to have the inspection report pull from api and not index
    setTimeout(() => {
      // inspection submitted we need to review and approve
      const watcher = observe(this.activity);
      this.activity.status = "Closed";
      this.activity.completedDateTime = new Date().toJSON();
      this.activity.completedByUserId = this.user.profile.sub;
      const patch = generate(watcher);

      this.activityService.jsonPatchWithPartitionKey(this.activity.id, patch, this.activity.accountId).subscribe(result => {
        this.ngOnInit();
      });
    }, 1200);
  }
}
